// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* search suggestion popup CSS starts */

.searchSuggestionDiv {
  width: 38.5%;
}

.input {
  padding-left: 10px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 135%;
  height: 35px;
  font-family: "Ruda", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  margin-left: 11%;
  margin-right: 18px;
  color: #555;
  outline-color: #68dff0;
}

.achieverNameOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.achieverNameDiv {
  overflow-y: scroll;
  height: auto;
  max-height: 200px;
  width: 310px;
  padding: 5px;
  border: 1px solid #aaa;
  background: white;
  position: absolute;
  border-radius: 10px;
  overflow-x: hidden;
  margin-right: 18px;
  margin-left: 36px;
  list-style: none;
  z-index: 1;
}

.achieverNameDiv::-webkit-scrollbar {
  width: 9px;
}

.achieverNameClose {
  margin-left: 252px;
  /* border: 1px solid #aaa; */
  margin-right: 5px;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 700;
  font-size: 13px;
  height: 25px;
  /* margin: 0; */
  padding: 6px 10px 5px 13px;
  cursor: pointer;
  outline: none;
}

.achieverNameClose:hover {
  background-color: #f2f2f2;
}
.achieverNameClose:focus {
  background-color: #f2f2f2;
}

.achieverNameClose:active {
  background-color: #aaa;
}

.achieverNameLine {
  margin: 5px;
}

.achieverNameUl {
  /* border-bottom: 1px solid #aaa; */
  font-family: Poppins;
  font-style: normal;
  font-size: 12px;
  cursor: pointer;
  height: 30px;
  margin: 0;
  padding: 6px 10px 5px 13px;
  /* border-radius: 5px; */
  border: none;
  outline: none;
}

.achieverNameUl:hover {
  background-color: #f2f2f2;
  border-radius: 5px;
}

.achieverNameUl:focus {
  background-color: #f2f2f2;
  /* border-radius: 5px; */
  border: none;
}

.achieverNameUl:active {
  background-color: #aaa;
  border-radius: 5px;
}

/* search suggestion popup CSS ends */
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/SearchSuggestion/searchSuggestion.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,wBAAwB;EACxB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qCAAqC","sourcesContent":["/* search suggestion popup CSS starts */\n\n.searchSuggestionDiv {\n  width: 38.5%;\n}\n\n.input {\n  padding-left: 10px;\n  margin-bottom: 8px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  border-radius: 4px;\n  width: 135%;\n  height: 35px;\n  font-family: \"Ruda\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  margin-left: 11%;\n  margin-right: 18px;\n  color: #555;\n  outline-color: #68dff0;\n}\n\n.achieverNameOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n}\n\n.achieverNameDiv {\n  overflow-y: scroll;\n  height: auto;\n  max-height: 200px;\n  width: 310px;\n  padding: 5px;\n  border: 1px solid #aaa;\n  background: white;\n  position: absolute;\n  border-radius: 10px;\n  overflow-x: hidden;\n  margin-right: 18px;\n  margin-left: 36px;\n  list-style: none;\n  z-index: 1;\n}\n\n.achieverNameDiv::-webkit-scrollbar {\n  width: 9px;\n}\n\n.achieverNameClose {\n  margin-left: 252px;\n  /* border: 1px solid #aaa; */\n  margin-right: 5px;\n  margin-bottom: 0;\n  margin-top: 0;\n  font-weight: 700;\n  font-size: 13px;\n  height: 25px;\n  /* margin: 0; */\n  padding: 6px 10px 5px 13px;\n  cursor: pointer;\n  outline: none;\n}\n\n.achieverNameClose:hover {\n  background-color: #f2f2f2;\n}\n.achieverNameClose:focus {\n  background-color: #f2f2f2;\n}\n\n.achieverNameClose:active {\n  background-color: #aaa;\n}\n\n.achieverNameLine {\n  margin: 5px;\n}\n\n.achieverNameUl {\n  /* border-bottom: 1px solid #aaa; */\n  font-family: Poppins;\n  font-style: normal;\n  font-size: 12px;\n  cursor: pointer;\n  height: 30px;\n  margin: 0;\n  padding: 6px 10px 5px 13px;\n  /* border-radius: 5px; */\n  border: none;\n  outline: none;\n}\n\n.achieverNameUl:hover {\n  background-color: #f2f2f2;\n  border-radius: 5px;\n}\n\n.achieverNameUl:focus {\n  background-color: #f2f2f2;\n  /* border-radius: 5px; */\n  border: none;\n}\n\n.achieverNameUl:active {\n  background-color: #aaa;\n  border-radius: 5px;\n}\n\n/* search suggestion popup CSS ends */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
